package com.mgacreative.hotel.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Department(
    val id: String,
    val tenant_id: String,
    val name: String,
    val permissions: List<String> = emptyList(), // Store screen IDs, e.g., ["AdminDashboardScreen", "HousekeepingScreen"]
    val created_at: String? = null
)
